import { OnBoardingModalContainer } from "./OnBoardingModal.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../stores";
import { ModalPortal } from "../../../common";

interface OnBoardingModalProps {}

export const OnBoardingModal = observer(({}: OnBoardingModalProps) => {
	const { settingsStore } = useStores();

	return (
		<ModalPortal modalStore={settingsStore.onboardingModal} center>
			<OnBoardingModalContainer>OnBoardingModal</OnBoardingModalContainer>
		</ModalPortal>
	);
});
